import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/digitaalkantoor.webp';
import screenshot_target from '../../../images/letterfunnel/bobsalm.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Bob Salm"
      firstname="Bob"
      companyname="Digitaal Kantoor"
      competition="Simplicate en Teamleader"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/bobsalm.js